import { createContext, useContext } from 'react';

export type SSRStatusContextValue = { statusCode?: number };

export const SSRStatusContext = createContext<SSRStatusContextValue | null>(null);

export const useSSRStatus = (): SSRStatusContextValue | null => useContext(SSRStatusContext);
